<template>
    <div class="humen-cell" :class="{ 'is-link': isLink }">
        <div class="avatar-icon">
            <img :src="person.avatar" alt @click="goProfesser" />
            <svg class="icon" aria-hidden="true" v-if="isLink">
                <use xlink:href="#iconzhuanjia" />
            </svg>
        </div>
        <div class="cell-right">
            <div class="top">
                <div class="name" @click="goProfesser">
                    <span class="black">{{ person.nickname }}</span>
                    <span v-for="(item, i) in person.label" :key="i">
                        {{
                        item.lname
                        }}
                    </span>
                </div>
                <div class="btn">
                    <el-button type="primary" round plain @click="consultation">
                        <span v-if="isLink">咨询</span>
                        <span v-else>私信</span>
                    </el-button>
                    <el-button type="primary" @click="setFollow" round :plain="!isfollow">
                        <span class="nomargin" v-if="isfollow == 1">取消</span>关注
                    </el-button>
                </div>
            </div>
            <div class="center">
                <span class="black85" v-if="person.work" @click="goProfesser">
                    {{
                    person.work
                    }}
                </span>
                <span v-if="person.website">
                    <span class="black85">网站：</span>
                    <span class="blue">
                        <el-link
                            :href="person.website"
                            target="_blank"
                            :underline="false"
                        >{{ person.website || "暂无" }}</el-link>
                    </span>
                </span>
            </div>
            <div class="bottom" @click="goProfesser">技术交流微信：{{ person.describe }}</div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        props: {
            person: {
                type: Object,
                default: {}
            },
            isLink: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                isfollow: this.person.isfollow
            };
        },
        computed: {
            ...mapGetters(['loginState'])
        },
        created() {},
        mounted() {},
        methods: {
            goProfesser() {
                if (this.isLink) {
                    this.$router.push({
                        name: 'expertcenter',
                        query: {
                            professor: this.person.followid || this.person.uid
                        }
                    });
                }
            },
            consultation() {
                //
                if (!this.loginState) {
                    this.$message({
                        type: 'error',
                        message: '您还没有登录，请先登录！'
                    });
                    return;
                }
                if (this.isLink) {
                    this.$router.push({
                        name: 'expertcenter',
                        query: {
                            professor: this.person.followid || this.person.uid,
                            buid: this.person.followid || this.person.uid
                        }
                    });
                } else {
                    this.$router.push({
                        name: 'personal-center',
                        query: {
                            buid: this.person.followid || this.person.uid
                        }
                    });
                }
            },
            setFollow() {
                if (!this.loginState) {
                    this.$message({
                        type: 'error',
                        message: '您还没有登录，请先登录！'
                    });
                    return;
                }
                this.httpPost(this.$root.setUserFollow, {
                    followid: this.person.followid || this.person.uid,
                    status: this.isfollow == 1 ? 2 : 1 // 1关注2 取关
                })
                    .then(result => {
                        if (result) {
                            this.isfollow = this.isfollow == 1 ? 0 : 1;
                            this.$emit('change');
                        }
                    })
                    .catch(err => {
                        console.error('setFollow-err', err);
                    });
            }
        },
        components: {},
        watch: {
            person: {
                handler(newV, oldV) {
                    this.isfollow = newV.isfollow;
                }
            }
        }
    };
</script>

<style lang='stylus' rel='stylesheet/stylus' scoped>
    @import '~assets/main.styl';

    .avatar-icon {
        position: relative;

        .icon {
            width: 30px;
            height: 30px;
            fill: #f0c328;
            position: absolute;
            right: 11px;
            top: -15px;
            transform: rotate(20deg);
            -ms-transform: rotate(20deg); /* IE 9 */
            -moz-transform: rotate(20deg); /* Firefox */
            -webkit-transform: rotate(20deg); /* Safari 和 Chrome */
            -o-transform: rotate(20deg); /* Opera */
        }
    }

    .humen-cell {
        width: 880px;
        min-height: 80px;
        padding: 24px;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 1);
        border-radius: 8px;
        flex-x(flex-start);
        margin-top: 16px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 22px;

        &.is-link {
            cursor: pointer;
        }

        img {
            width: 80px;
            height: 80px;
            border-radius: 45px;
            margin-right: 10px;
        }

        .cell-right {
            width: 744px;
            height: 100%;
            flex-y(space-between, space-between);
        }

        span {
            margin-right: 18px;
        }

        .black {
            font-size: 16px;
            font-weight: 500;
            color: rgba(0, 0, 0, 1);
            line-height: 22px;
            font-weight: bold;
        }

        .black85 {
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
        }

        .blue, .el-aside {
            font-size: 14px;
            font-weight: 400;
            color: rgba(25, 125, 255, 1);
            line-height: 22px;
        }

        .blue .el-link.el-link--default {
            color: rgba(25, 125, 255, 1) !important;
        }

        .nomargin {
            margin-right: 0;
        }

        .top {
            width: 100%;
            flex-x(space-between);

            .name {
                width: 78%;
                flex-wrap: wrap;
            }

            .btn {
                width: 20%;
                flex-x();

                .el-button {
                    width: 72px;
                    height: 32px;
                    line-height: 32px;
                    border-radius: 20px;
                    padding: 0;

                    span {
                        margin-right: 0;
                    }
                }

                .el-button:hover {
                    width: 72px;
                    height: 32px;
                    padding: 0;
                }
            }
        }

        .center {
            flex-wrap: wrap;
            margin-top: 10px;
        }

        .bottom {
            flex-wrap: wrap;
        }
    }
</style>
